module.exports = __webpack_public_path__ + "static_pc/img/28.4d269bff.jpg";